import $ from 'jquery';
import axios from "axios";

$(document).ready(function() {

    //causes an error
    /*
    $('.video-yt').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });
    */

});
$(function() {

    // $('.liame').nospam({ filterLevel: 'normal',replaceText: true  });
    // $('.email').nospam({ filterLevel: 'normal',replaceText: false  });



    //mobile menu stuff
    // equalizeSubmenuHeights();
    // $(window).on('resize', equalizeSubmenuHeights);

    $('.openmenu').on('click', function(e){
        console.log('openmenu: click');
        e.preventDefault();
        // Check if the menu is open (menuon class on burger icon)
        if ($(this).hasClass('menuon')) {
            // Menu is already open
            $(this).removeClass('menuon');
            $('body').removeClass('menuopen');
            $('.overlay .submenu').css({'left': '100%','opacity': '1'});
            $('.sidenavinner').fadeOut(50);
            $('.overlay').delay(200).css({'height': '0','top': '100%'});
        } else {
            $(this).addClass('menuon');
            $('body').addClass('menuopen');
            $('.sidenavinner').delay(400).fadeIn();
            if ($(window).width() < 601) {
                $('.overlay').css({'height': '100vh','top': '0'});
            } else {
                $('.overlay').css({'height': '100vh','top': '0'});
            }
        }
    });

    // $('.sticky-edit-close').click(function() {
    //     $('.sticky-edit-order').fadeOut();
    // });

    // $('.openoffers').click(function() {
    //     $('.wrapper-offers').css({'top': '0'});
    //     $('.wrapper-offers-mask').delay(350).fadeIn(150);
    // });
    // $('.closeoffers').click(function() {
    //     $('.wrapper-offers-mask').hide();
    //     $('.wrapper-offers').css({'top': '100%'});
    // });


    $('.opennews').click(function () {
        $('.latestnewsmin').hide();
        //$('.latestnews').slideUp('fast');
        $('.latestnews').css({'display': 'block'});
        return false;
    });

    $('.closenews').click(function () {
        $('.latestnews').hide();
        if ($(window).width() < 769) {
            $('.latestnewsmin').show();
        }
        return false;
    });

    $('.menuclosebtn').click(function () {
        console.log('menuclosebtn: click');
        $('.openmenu').removeClass('menuon');
        $('body').removeClass('menuopen');
        $('.overlay .submenu').css({'left': '100%','opacity': '1'});
        $('.hdrsearch').slideUp();
        $('.sidenavinner').fadeOut(50);
        $('.overlay').delay(200).css({'height': '0','top': '100%'});
        //return false;
    });

    // $('#sidenav li.expandable > button').on('click', function (e) {
    //     console.log('sidenav li.expandable > button: click');
    //     e.preventDefault();
    //     $(this).closest('li.expandable').find('.submenu:first').css({'left': '0','width': '100%','opacity': '1'});
    //     $(this).closest('li.expandable').find('.submenu ul').delay(100).fadeIn();
    //     //return false;
    // });

    $('a.navback').on('click', function (e) {
        console.log('a.navback: click');
        e.preventDefault();
        $(this).closest('li.expandable').find('.submenu:first').css({'left': '100%','width': '0','opacity': '0'});
        $(this).closest('li.expandable').find('.submenu ul').fadeOut(50);
        //return false;
    });
    //end mobile menu stuff

    //start megamenu stuff
    $(function() {
        $('.nojs').removeClass('nojs');

        var open = null;
        var megamenu = $('.megamenu');
        var megawrapper = $('.megamenu-wrapper');

        let showDelay = 50;

        var openMenu = function(el, callback) {

            var li = $(el).closest('li');
            var submenu = $(li).find('ul').eq(0).clone();
            var menuscroll1 = $('.headernav ul.menu_depth_2').clone();
            var menuscroll2 = $('.headernav ul.menu_depth_3').clone();

            megamenu.html('<div class="menuscroll1"></div><div class="menuscroll2"></div>');
            //$('.headernav ul.menu_depth_3').clone().appendTo('.menuscroll2');
            //$('.headernav ul.menu_depth_2').clone().appendTo('.menuscroll');
            menuscroll1.appendTo('.menuscroll1');
            menuscroll2.appendTo('.menuscroll2');
            submenu.prependTo(megamenu);

            $('.menuclass_megamenu').removeClass('open');
            $(el).closest('li').addClass('open');

            megawrapper.fadeIn(300, function() {
                open = $(el);
                if (callback) callback(el);
            });

            $(".megamenu ul.menu_depth_1 > li.expandable > a").append('<span class="expander"></span>');
            $('.megamenu ul.menu_depth_1 > li.expandable > a span.expander').click(function() {
                console.log('menu_depth_1 span.expander: click');
                $('ul.menu_depth_1 span.expander').not(this).removeClass('open');
                $(this).toggleClass('open');
                var linkid = $(this).closest('li.expandable').attr('id');
                console.log('linkid: ' + linkid);
                var submenuid = linkid.replace("linkid_", "");
                console.log('submenuid: ' + submenuid);
                $('ul.menu_depth_2').not("#submenu_" + submenuid).hide();
                //$(' #submenu_' + submenuid).show();
                $('ul.menu_depth_3').hide();
                $('ul.menu_depth_2 span.expander').removeClass('open');
                $('.menuscroll1 #submenu_' + submenuid).css('display', 'block;');
                $(".menuscroll1 #submenu_" + submenuid).fadeToggle('fast');
                return false;
            });

            $(".megamenu ul.menu_depth_2 > li.expandable > a").append('<span class="expander"></span>');
            $('.megamenu ul.menu_depth_2 > li.expandable > a span.expander').click(function() {
                console.log('menu_depth_2 span.expander: click');
                $('ul.menu_depth_2 span.expander').not(this).removeClass('open');
                $(this).toggleClass('open');
                var linkid = $(this).closest('li.expandable').attr('id');
                var submenuid = linkid.replace("linkid_", "");
                $('ul.menu_depth_3').not("#submenu_" + submenuid).hide();
                $("#submenu_" + submenuid).fadeToggle('fast');
                $("#submenu_" + submenuid + '.menu_depth_3.imgmenu').css('display', 'block;');
                return false;
            });
        }

        function closeMenu(callback) {
            console.log('closeMenu');
            $('.menuclass_megamenu').removeClass('open');
            megawrapper.fadeOut(300, function() {
                open = null;
                if (callback) callback();
            });
        }



        $('.headernav .menu_depth_0 > li.menuclass_megamenu > a, .headernav .menu_depth_0 > li.menuclass_megamenu > a i').click(function(e) {
            //console.log('li.menuclass_megamenu a: click');

            // Need to handle situation where the dropdown link also has a URL ...
            var el = $(this);
            e.stopPropagation();

            var href = false;
            if (el.is('a')) {
                href = el.attr('href');
            }

            if (!href) {
                e.preventDefault();
                if (open && open.is(el)) {
                    closeMenu();
                } else {
                    if (open) {
                        closeMenu(function() {
                            openMenu(el);
                        });
                    } else {
                        openMenu(el);
                    }
                }
            }

        });
    });
    //end megamenu stuff

    //hide checkout bar div on scroll up/down
    var lastScrollTop = 0;
    $(window).scroll(function(){
        handleScroll();
    });

    $(window).resize(function() {
        handleScroll();
    });

    function handleScroll() {
        //console.log('handleScroll');
        var st = $(window).scrollTop();
        var banner = $('.checkout-bar');
        var merlinOfflineAlert = $('.merlin-offline');
        if (merlinOfflineAlert) {
            console.log(merlinOfflineAlert.outerHeight());
        }
        if (st > lastScrollTop){
            banner.addClass('show');
            if (merlinOfflineAlert) {
                $('header').css('top',merlinOfflineAlert.outerHeight() + 'px');
            } else {
                $('header').css('top','0px');
            }
        } else {
            banner.removeClass('show');
            if (merlinOfflineAlert) {
                $('header').css('top',merlinOfflineAlert.outerHeight() + 'px');
            } else {
                $('header').css('top','45px');
            }
        }
    }

    $(".hvrproduct").hover(function() {
        $(this).find(".hvrproductover").fadeToggle(500);
    });

    // This is the mobile version of the homepage hero carousel
    $('.hero-slider').slick({
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="fa-solid fa-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.homepage-offer-new-trending-slider').slick({
        autoplay: false,
        centerMode: false,
        infinite: false,
        variableWidth: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="fa-solid fa-circle-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="fa-solid fa-circle-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 1412,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1129,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 847,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 564,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]

    });


    $('.guest-brand-slider').slick({
        autoplay: false,
        centerMode: false,
        infinite: false,
        variableWidth: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.guest-brand-slider-nav-thumbnails',
        responsive: [
            {
                breakpoint: 1129,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });


    $('.guest-brand-slider-nav-thumbnails').slick({
        autoplay: false,
        centerMode: false,
        infinite: false,
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.guest-brand-slider',
        dots: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="fa-solid fa-circle-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="fa-solid fa-circle-chevron-right"></i></button>',
        focusOnSelect: true,
    });


    $('.product-slider').slick({
        centerMode: false,
        infinite: true,
        variableWidth: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="fa-solid fa-circle-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="fa-solid fa-circle-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.featured-slider').slick({
        autoplay: true,
        centerMode: false,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.slider-nav-thumbnails',
        responsive: [
            {
                breakpoint: 1412,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1129,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 847,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 564,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    $('.slider-nav-thumbnails').slick({
        autoplay: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.featured-slider',
        arrows: true,
        dots: false,
        focusOnSelect: true,
        prevArrow: '<button type="button" class="slick-prev" aria-label="previous"><i class="fa-solid fa-circle-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="next"><i class="fa-solid fa-circle-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Remove active class from all thumbnail slides
    $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

    // Set active class to first thumbnail slides
    $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

    // On before slide change match active thumbnail to current slide
    $('.featured-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var mySlideNumber = nextSlide;
        $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
        $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
    });

    mobileOnlySlider(".keypoints", false, true, 991);

    $("#toTop").click(function(){
        //event.preventDefault();
        $("html, body").animate({
            scrollTop:0
        },"slow");
    });

    $('.qtyplus').click(function(e){
        e.preventDefault();
        fieldID = $(this).attr('field');
        var currentVal = parseInt($('input[id='+fieldID+']').val());
        if (!isNaN(currentVal)) {
            $('input[id='+fieldID+']').val(currentVal + 1);
        } else {
            $('input[id='+fieldID+']').val(1);
        }
    });
    $(".qtyminus").click(function(e) {
        e.preventDefault();
        fieldID = $(this).attr('field');
        var currentVal = parseInt($('input[id='+fieldID+']').val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $('input[id='+fieldID+']').val(currentVal - 1);
        } else {
            $('input[id='+fieldID+']').val(1);
        }
    });

    $('.autoplay').slick({
        autoplay: true,
        autoplaySpeed: 2500,
        centerMode: true,
        infinite: true,
        fade: true,
        dots: false,
        speed: 1600,
        appendArrows: $('.slider-buttons'),
        dotsClass: 'slick-dots page-widthn page-center' //allows for moving on product pages
    });

    if (typeof $.fn.masonry !== 'undefined') {
        $('.knowus-wrapper').masonry({
            // options
            itemSelector: '.knowus-panel',
            columnWidth: '.knowus-sizer',
            percentPosition: true
        });

        if ($('.knowus-wrapper').length > 0) {
            $('.knowus-content').each(function() {
                var
                    x1 = 1000-(Math.random()*2000),
                    y1 = 1000-(Math.random()*2000),
                    x2 = 1000-(Math.random()*2000),
                    y2 = 1000-(Math.random()*2000);

                $(this).css({
                    'background-position': x1+'px '+y1+'px, '+x2+'px '+y2+'px'
                });

            });
        }
    }

    // Buy item ajax functionality
    var addedPopupHtml = false;

    $('form[name="AddBasket"] input[type=submit], .tabproductadd > form input[type=submit], form[name^="buyform_"] input[type=submit]').click(function() {
        $(this).removeClass('clicked');
        $(this).addClass("clicked");
        $(this).val("ORDERED");
    });

    $('form[name="AddBasket"], .tabproductadd > form, form[name^="buyform_"]').submit(function(){
        var val = $("input[type=submit]").val();

        if (val == "ADD TO WISH LIST"){
        } else {
            // this file is included before linkPath is defined
            // setup ajax Object
            var $SubmittedQty = $(this).find("input[name=Qty]");
            if ($.isNumeric($SubmittedQty.val()))
            {if ($SubmittedQty.val() == 0) {$SubmittedQty.val('1')};
            } else
            {$SubmittedQty.val('1')};
            var serialiseData = "Ajax_AddToBasket=1&" + $(this).serialize();

            var basketupdatepage = 0;
            if (serialiseData.indexOf("basketupdate") !== -1) {basketupdatepage = 1} ;
            var request = $.ajax({
                url: $(this).attr('action'),
                type: $(this).attr('method'),
                dataType: "json",
                cache: false,
                data: serialiseData,
                success: function(response){

                    if (response.basketinfo[0].current_basket_value !== undefined){
                        var newCurrentBasketValue = response.basketinfo[0].current_basket_value;
                        var current_basket_Wascommitted	= response.basketinfo[0].current_basket_committed;
                        var current_basket_commit_datestamp	= response.basketinfo[0].current_basket_commit_datestamp;

                        if (basketupdatepage == 1) {FetchBasket();};
                    }

                    if (basketupdatepage == 0){
                        //do we have a time for the commit?
                        if (current_basket_commit_datestamp.includes(":")){
                            var sPopupTitle = "You have added an item to your current order";
                            if (current_basket_Wascommitted =="1"){
                                var sPopupMessage = "<p>You have just added an item to your <a href='/basket.asp'>current order</a>.</p><p>You have until <b>" + current_basket_commit_datestamp + "</b> to make any amends. After this time it will be processed by our team.</p>";
                            } else {
                                var sPopupMessage = "<p>You have just added an item to your <a href='/basket.asp'>current order</a>.</p><p style='color:red'>Your previously committed order is on hold while you amend it. <br /><b>You must hit Place Order on the current order page</b> again to ensure it is processed by our team.</p>";
                            }
                            var newCurrentBasketCount = 'Current Order for processing at ' + current_basket_commit_datestamp + ' (' + response.basketinfo[0].current_basket_count + ')';
                        } else {
                            var sPopupTitle = "Added to basket";
                            var sPopupMessage = "<p>You have just added that item into your <a href='/basket.asp'>basket</a></p>";
                            var newCurrentBasketCount = 'Basket (' + response.basketinfo[0].current_basket_count + ')';
                        }

                        sPopupMessage = sPopupMessage.concat("<p><a href='#' class='jqmClose'>Continue browsing</a></p>");

                        if (!addedPopupHtml) {
                            $('#footer_wrapper_outer').append('<div class="jqmWindow" id="popuptext"><h3>' + sPopupTitle + '</h3><div>' + sPopupMessage  + '</div></div>');
                            addedPopupHtml = true;
                        } else {
                            $('#popuptext').html('<h3>' + sPopupTitle + '</h3><div>' + sPopupMessage  + '</div>');
                        }
                    }

                    var myClose=function(hash) {
                        hash.w.fadeOut('2000',function(){ hash.o.remove(); });
                    };
                    $('#current_basket_count span.headerbasketinfo').html(newCurrentBasketCount);
                    $('#current_basket_value').fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300);
                    $('#current_basket_count').fadeOut(300).fadeIn(300).fadeOut(300).fadeIn(300);

                    $('#popuptext').jqm({overlay:60,toTop:true,onHide:myClose}).jqmShow({});
                }
            });
            return false;
        }
    });

    $('img.whopanelimg').hover(function(){
        //$(this).toggleClass("grayscale", 500)
        $(this).toggleClass("fullcolor");
        //alert('hello');
    });

    $('.basket-summary-inner h4').click(function(){
        if ($(window).width() < 982) {
            $('.basket-summary-content').toggleClass('open').slideToggle();
            $(this).toggleClass('open');
        }
    });

});



// $(window).on("resize", function () {
//     if ($(document).width() > 981) {
//         $('.basket-summary-content').removeClass('open').css('display', 'block');
//         $('.basket-summary-inner h4').removeClass('open');
//     } else {
//         $('.basket-summary-content').removeClass('open').css('display', 'none');
//         $('.basket-summary-inner h4').removeClass('open');
//     }
// });

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
        mobileFirst: true,
        dots: $dots,
        arrows: $arrows,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 800,
        responsive: [
            {
                breakpoint: $breakpoint,
                settings: "unslick"
            }
        ]
    };

    slider.slick(settings);

    $(window).on("resize", function () {
        if ($(window).width() > $breakpoint) {
            return;
        }
        if (!slider.hasClass("slick-initialized")) {
            return slider.slick(settings);
        }
    });
} // Mobile Only Slider

function equalizeSubmenuHeights() {
    let maxHeight = 0;
    $('.sidenav .submenu').each(function () {
        const h = $(this).outerHeight();
        if (h > maxHeight) maxHeight = h;
    });
    $('.sidenav .submenu').css('min-height', maxHeight + 'px');
}

(function(d) {
    var config = {
            kitId: 'qra5rqp',
            scriptTimeout: 3000,
            async: true
        },
        h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);



$(function() {
    var trans = null;
    var hasBanner = $('.content-wrapper.hasBanner').length > 0;

    var scrollfunc = function() {
        var scrolltop = $(document).scrollTop();

        $('.header').toggleClass('small', scrolltop > 43); // 139 - 89 = 43px


        if (!hasBanner) {
            var sh = 132;
            var pct = (Math.min(scrolltop, sh)/sh) * 0.26;
            if (!isFinite(pct))
                pct = 0;

            pct = 1 - pct;
            if (trans != pct) {
                trans = pct;
                // JM commented out for IE8
                //$('.header').css({
                //	background: 'rgba(0, 55, 38, '+(pct)+')'
                //});
            }
        }

    };

    // $(window).scroll(scrollfunc);
    // scrollfunc();
});

$(function() {
    var drop = $('.headersearch-drop');
    var box = drop.find('input');
    // search stuff in header
    $('.headersearch-toggle').click(function() {
        box.focus();
    });

    drop.focusin(function() {
        drop.toggleClass('collapsed', false);
    });

    drop.focusout(function() {
        setTimeout(function() {
            if (!drop.is(':focus')) {
                drop.toggleClass('collapsed', true);
            }
        }, 500);
    });

});

$(function() {
    $(document).on('click', '.nav-toggle-dropdown', function() {
        $(this).siblings('.nav-sub-menu').toggleClass('open');
        $(this).toggleClass('active');
    });
});

$(document).on('click', '.toggle-nav button', function() {
    $('body').toggleClass('nav-toggled');
});

$('a[href$="#"]').click(function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
});

$(window).scroll(function(){
    if ($(window).scrollTop() >= 300) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
});

$(function() {
    $('.careers-panel .image').click(function() {
        var section = $(this).closest('.careers-panel');
        var image = $(this);
        var editorial = section.find('.editorial');

        var expanded = section.hasClass('expanded');

        editorial.stop();
        section.stop();

        section.toggleClass('expanded', !expanded);
        editorial.slideToggle(expanded);

    });
});

$(function() {
    let ddpPopup = document.getElementById("delivery-dates-popup");

    if (ddpPopup) {
        // Only show the popup if it hasn't been closed before
        let ddpClosed = localStorage.getItem("DDPClosed");
        if (!ddpClosed) {
            ddpPopup.style.display = "flex";
        }

        $(document).on('click', '.delivery-date-notification-close', function(e) {
            e.preventDefault();
            ddpPopup.style.display = "none";
            localStorage.setItem("DDPClosed", "true");
        });
    }

});

$(function() {

    $(document).on('click', '.one-click', function (e) {
        if ($(this).data('clicked')) {
            e.preventDefault();
        } else {
            $(this).addClass('clicked').data('clicked', true);
        }
    });

});
